module.exports = __webpack_public_path__ + "acfcc7374140f35d9be70b5e856cae29.png";